import { render, staticRenderFns } from "./Referenzen.vue?vue&type=template&id=19bb5aa0&scoped=true&"
import script from "./Referenzen.vue?vue&type=script&lang=ts&"
export * from "./Referenzen.vue?vue&type=script&lang=ts&"
import style0 from "./Referenzen.vue?vue&type=style&index=0&id=19bb5aa0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb5aa0",
  null
  
)

export default component.exports